import { render } from "./TrainIcon.vue?vue&type=template&id=2ff63e46&scoped=true"
const script = {}

import "./TrainIcon.vue?vue&type=style&index=0&id=2ff63e46&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ff63e46"]])

export default __exports__